import React from "react";
import Footer from "../../components/Footer";
import GroupForm from "../../components/forms/Communicate/Group"
import NavBar from "../../components/navbar-components/NavBar";

const Group = () => {
    return (
        <>
        <NavBar/>
        <div className="bg-gray-200 py-5">
            <GroupForm/>
        </div>
        <Footer/>
        </>
    )
}

export default Group